import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Button from '../../common/button/button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Dialog from '../../layout/dialog/dialog.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogSpreadsheetExport extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      noExpense: PropTypes.number,
      onExportExcel: PropTypes.func,
      onExportCsv: PropTypes.func,
      i18nTitleKey: PropTypes.string,
      i18nSubTitleKey: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      noExpense: 0,
      onExportExcel: null,
      onExportCsv: null,
      i18nTitleKey: '',
      i18nSubTitleKey: ''
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  isActive () {
    return this.state.active
  }

  render () {
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
      >
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='title'>
                  <IntlMessage ident={this.props.i18nTitleKey} />
                </div>
                <div className='msg'>
                  {this.props.noExpense || ''} <IntlMessage ident={this.props.i18nSubTitleKey} />
                </div>
              </div>
            </div>
          </div>
          <div className='actionboard-footer'>
            <div className='actionboard-row'>
              <div className='actionboard-col2'>
                <div
                  className='action-btn'
                  onClick={this._onExcelExport.bind(this)}
                >
                  <Button
                    title='expense.list.buttonXlsx'
                    className='button_dialog'
                  />
                  <span className='label'>
                    <IntlMessage ident='expense.list.exportXlsxLabel' />
                  </span>
                </div>
              </div>
              <div className='actionboard-col2'>
                <div
                  className='action-btn'
                  onClick={this._onCsvExport.bind(this)}
                >
                  <Button
                    title='expense.list.buttonCsv'
                    className='button_dialog'
                  />
                  <span className='label'>
                    <IntlMessage ident='expense.list.exportCsvLabel' />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  _onExcelExport (ev) {
    ev.preventDefault()

    if (this.props.onExportExcel) {
      this.props.onExportExcel(ev)
    }
  }

  _onCsvExport (ev) {
    ev.preventDefault()

    if (this.props.onExportCsv) {
      this.props.onExportCsv(ev)
    }
  }
}

export default DialogSpreadsheetExport
